import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpDescr } from './op-descr'
import { Utils } from '../util/utils'

export class OpCurrency implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idCurrency: number
    public name: string
    public idDescr: number
    public descr: OpDescr
    public symbol: string

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdCurrency
    }
    public getReferenceKey(): number {
        return this.idCurrency
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idCurrency = opObj.ID_CURRENCY
            this.name = opObj.NAME
            this.idDescr = opObj.ID_DESCR
            this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
            this.opState = opObj.OpState
            this.symbol = opObj.SYMBOL
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_CURRENCY: this.idCurrency,
            SYMBOL: this.symbol,
            NAME: this.name,
            ID_DESCR: this.idDescr,
            _Descr: this.descr != null ? this.descr.toJSON() : null,
            OpState: this.opState
        }
    }

    public toString() {
        return Utils.isNullOrEmpty(this.symbol) ? this.name : this.symbol
    }
}